<template>
  <div id="header" class="header">
    <csm-banner />
    <top-bar />
    <main-bar />
    <nav-bar />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* Components */
import TopBar from './top-bar/top-bar.vue';
import MainBar from './main-bar.vue';
import NavBar from './nav-bar.vue';
import CsmBanner from './csm-banner.vue';

export default {
  name: 'Header',
  components: {
    TopBar,
    MainBar,
    NavBar,
    CsmBanner,
  },
  computed: {
    ...mapGetters({
      MAIN_MENU: 'menu/mainMenu',
    }),
  },
  mounted () {
    // Если не загрузили меню на сервере, подгружаем на клиенте
    if (this.MAIN_MENU?.length) return;
    this.LOAD_MENU();
  },
  methods: {
    ...mapActions({
      GET_CITY: 'user/getCity',
      LOAD_MENU: 'menu/loadMainMenu',
    }),
  },
  serverPrefetch () {
    return Promise.all([
      this.GET_CITY(),
      this.LOAD_MENU(),
    ]);
  },
};
</script>

<style lang="scss">
.header {
  border-bottom: 1px solid $gray_lu;
  box-shadow: 0 4px 32px rgba(0, 0, 0, .08);
}
</style>
